export const duplicateVehicleModalQueryParam = 'duplicate_vehicle_modal'
export const duplicateVehicleUUIDQueryParam = 'duplicate_vehicle_uuid'
export const duplicateVehicleVinQueryParam = 'duplicate_vehicle_vin'
